<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="columns">
      <div class="column is-2">
        <div class="control">
          <label class="label is-small">Employee ID</label>
          <div class="field">
            <p v-text="timeSheet.employeeId"></p>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="control">
          <label class="label is-small">Name</label>
          <div class="field">
            <p v-text="timeSheet.employeeName"></p>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="control">
          <label class="label is-small">Period</label>
          <div class="field">
            <p v-text="timeSheet.datePeriod"></p>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="control">
          <label class="label is-small">Note</label>
          <div class="field">
            <textarea
              v-model="timeSheet.note"
              class="input is-small"
            />
            </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="control">
          <label class="label is-small">Status</label>
          <div class="field">
              <div class="select is-small">
                <select v-model="timeSheet.status">
                    <option value="0">Pending</option>
                    <option value="1">Approve</option>
                    <option value="2">Disapprove</option>
                </select>
              </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="control">
          <label class="label is-small">&nbsp;</label>
          <div class="field">
              <button :class="buttonSave" @click="saveAndSendEmail">Save & notify employee</button>
              &nbsp;
              <router-link :to="{name: 'List Of TimeSheet for Modification'}" class="button is-small">Go back to list</router-link>
          </div>
        </div>
      </div>
    </div>
    <div style="clear:both" />
    <b-table
      :data="timeSheet.timeSheetForModificationDetails"
      :bordered="true"
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :mobileCards="true"
    >
      <template slot-scope="item">
        <b-table-column
          field="dateLog"
          class="table-column-content-is-small"
          label="Date Log"
        >
          {{item.row.dateLog}}
        </b-table-column>
        <b-table-column
          field="day"
          class="table-column-content-is-small"
          label="Day"
        >
          {{item.row.day}}
        </b-table-column>
        <b-table-column
          field="checkIn"
          class="table-column-content-is-small"
          label="Check In"
        >
          {{item.row.checkIn}}
        </b-table-column>
        <b-table-column
          field="checkOut"
          class="table-column-content-is-small"
          label="Check Out"
        >
          {{item.row.checkOut}}
        </b-table-column>
        <b-table-column
          field="adjustment"
          class="table-column-content-is-small"
          label="Adjustment Note"
        >
          {{item.row.adjustmentNote}}
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    timeSheet: {
      status: 0,
    },
    buttonSave: appButton.isLoadingSuccess(false),
        isLoading: false
  }),
  created() {
    var timesheetformodificationId = this.$route.params.timesheetmodificationId;
    if (timesheetformodificationId) {
      this.getById(timesheetformodificationId);
    }
  },
  methods: {
    getById(id) {
      this.isLoading = true
      axios
        .get(`api/timesheetformodifications/${id}`)
        .then(response => {
          this.timeSheet = response.data;
        })
        .catch(error => console.log(error)).then(()=>{
          this.isLoading = false
        })
    },
    saveAndSendEmail() {
      this.buttonSave = appButton.isLoadingSuccess(true)
        const statusAndNote = {
            timeSheetForModificationId: this.$route.params.timesheetmodificationId,
            status: this.timeSheet.status,
            note: this.timeSheet.note
        }
        axios.put(`api/timesheetformodifications/${statusAndNote.timeSheetForModificationId}`, statusAndNote).then(response=>{
            appToast.success(response.data)
        })
        .catch(error=>console.log(error)).then(()=>{
          this.buttonSave = appButton.isLoadingSuccess(false)
        })
    }
  }
};
</script>
